<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>
        <div>
          <div class="info--text">
            <v-icon medium>router</v-icon>
            <strong>Survey Data</strong>
          </div>
          <div class="body-2">
            Summary
          </div>
        </div>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider />
    <v-card v-if="wideForm" class="card-bg-4">
      <SurveyDataSummary class="mb-2" data-ui-component="Survey Summary" :dataSource="surveyDataSource" />
      <v-layout>
        <!-- <v-flex xs6 class="pr-1">
          <PlotDataSourceInformationTable data-ui-component="Plot Metadata" :editForm="editForm" :dataSource="surveyDataSource" />
        </v-flex>
        <v-flex xs6 class="pl-1" data-ui-component="Aliases and Plot Hierarchy">
          <PlotDataSourceSpecimenaSummary class="mb-1" data-ui-component="Specimen Count" :dataSource="surveyDataSource" />          
          <PlotAliases data-ui-component="Aliases" :editForm="editForm" :dataSourceIndex="surveyDataSourceIndex" />          
        </v-flex> -->
      </v-layout>
    </v-card>
    <!-- <v-card v-else class="card-bg-4">
      <PlotDataSourceSurveySummary class="mb-2" :dataSource="surveyDataSource" />
      <PlotDataSourceSpecimenaSummary class="mb-2" :dataSource="surveyDataSource" />
      <PlotDataSourceInformationTable class="mb-2" :editForm="editForm" :dataSource="surveyDataSource" />
      <PlotAliases :editForm="editForm" :dataSourceIndex="surveyDataSource" />
    </v-card> -->
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const datasource = createNamespacedHelpers('datasource')

  import SurveyDataSummary from './Details/SurveyDataSummary'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    components: {      
      SurveyDataSummary,
    },
    props: {
      editForm: Boolean,
      wideForm: Boolean,
    },
    computed: {
      ...datasource.mapGetters(['dataSourceIndex']),
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData', 'currentFeatureDataSourceIndexByType']),
      // data source for plot data tabs and summary details
      surveyDataSource() {
        const data = this.currentFeatureDataSourceData(SOURCE_TYPES.surveysEnvirodata)
        return data
      },
      // data source index for alias information
      surveyDataSourceIndex() {
        const sourceId = this.surveyDataSource && this.surveyDataSource.Id
        if (sourceId == null) {
          return {}
        }
        return (this.dataSourceIndex && this.dataSourceIndex[SOURCE_TYPES.surveysEnvirodata] && this
          .dataSourceIndex[
            SOURCE_TYPES.surveysEnvirodata][sourceId]) || {}
      },
    },
  }
</script>